/** @file Draw Order panel registration: setup order, or draw-order keys at the playhead in Animate mode. */
import { rigPanel } from '../rigKit/rigPanel';
import { DrawOrderView } from './DrawOrderView';

/** Rig panel over slot.setDrawOrder and animation.setDrawOrderKey. */
export const panel = rigPanel('drawOrder', 'panels.drawOrder.title', DrawOrderView);
